import { getEntityName } from "../user/get-entity-name"

export const UNRESOLVED_USER_LABEL = "Unavailable user"

/**
 * The record a form edits usually carries the full objects behind its selected
 * ids, while the picker's option list is fetched separately and can omit them.
 * This turns the record's own objects into the label source of last resort.
 */
export function buildEntityLabelMap(
  entities?: ({ id?: string | number } & Record<string, any>)[] | null,
  byDefault: string = UNRESOLVED_USER_LABEL
): Map<string, string> {
  return new Map(
    (entities ?? []).map((entity) => [
      String(entity?.id),
      getEntityName(entity, byDefault)
    ])
  )
}
